import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'

import { useRootLocale } from 'lib/helpers/useLocale'
import { PlatformType } from 'lib/types/platform'

import ElButton from 'element/ElButton'
import ElTag from 'element/ElTag'
import BackButton from 'components/buttons/BackButton.vue'
import TextLink from 'components/buttons/TextLink.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthScope',
  props: {
    platform: null
  },
  emits: ['submit'],
  setup(__props: any, { emit }) {

const props = __props as {
  platform: PlatformType
}



const locale = computed<any>(() => {
  let base = 'views.auth.scopeTwitch'

  if (props.platform === 'youtube') {
    base = 'views.auth.scopeYoutube'
  }
  if (props.platform === 'trovo') {
    base = 'views.auth.scopeTrovo'
  }
  if (props.platform === 'vkplay') {
    base = 'views.auth.scopeVkplay'
  }

  return {
    heading: useRootLocale(`${base}.heading`),
    headline: useRootLocale(`${base}.headline`),
    info: useRootLocale(`${base}.info`),
    link: useRootLocale(`${base}.link`),
    desciptions: useRootLocale(`${base}.desciptions`),
    redirectBtn: useRootLocale(`${base}.redirectBtn`),
    linkHref: useRootLocale('links.whyAreWeCollectingThisData'),
  }
})



const root = ref<Node>()
const pending = ref(false)
const listIsOpened = ref(false)

const toggleList = () => {
  listIsOpened.value = !listIsOpened.value
}

const submit = () => {
  pending.value = true
  emit('submit')
}

onMounted(() => {
  document.getElementsByTagName('body')[0].appendChild(root.value as Node)
})

return { __sfc: true,props, locale, emit, root, pending, listIsOpened, toggleList, submit, ElButton, ElTag, BackButton, TextLink }
}

})